import { render, staticRenderFns } from "./TableActivitiesContainer.vue?vue&type=template&id=507228e6&"
import script from "./TableActivitiesContainer.vue?vue&type=script&lang=ts&"
export * from "./TableActivitiesContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports